<template>
  <div class="cards d-grid" :class="`${resourceType}_cards`" style="gap: 1rem" :style="getGridStyle(resource.meta.config.component?.cols)">
    <div
      v-for="(model, key) in resource.data"
      :key="key"
      class="card overflow-hidden product">
      <div v-if="options.extra" class="card-header" style="color: var(--primary-color)">
        {{ options.extra.title }}
        <presentation-field
          :column="''"
          :column-type="'date'"
          :mutation="'date'"
          :show-id="false"
          :resource-type="resourceType"
          :value="options.extra.data[key]"
          :options="{ showCalendar: false }"
          style="color: var(--primary-color)"
        ></presentation-field>
      </div>
      <div class="d-flex flex-column justify-content-between card-img-top card-img text-center" style="border-right: var(--border-width) solid var(--border-color)">
        <img
          v-if="model.data.attributes.image_preview_url || options.placeholder_image"
          :src="model.data.attributes.image_preview_url || options.placeholder_image"
          style="object-fit: contain"
        />
        <div
          v-else-if="model.data.attributes.icon_class ?? resource.meta.decoration.attributes"
          class="d-flex flex-column align-items-center justify-content-center"
          style="height:8rem;"
        >
          <colored-icon
            style="font-size: 3rem;"
            :icon-class="model.data.attributes.icon_class"
            :color="model.data.attributes.icon_color"
            :shadow="false"
          ></colored-icon>
        </div>
        <toggle :value="true" class="mt-3"></toggle>
      </div>
      <Link :href="route(`${routePrefix}.${resourceType}.show`, model.data.id)" class="w-100">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-top">
            <h5 class="card-title flex-grow-1 fs-5 fw-bold">
              {{ model.data.attributes[options.title_key] }}
            </h5>
            <div class="d-flex align-items-center">
              <div v-if="model.data.attributes.package_name" class="pe-1" style="opacity:0.5; font-size:0.875rem">
                <presentation-field
                  :column="'package_name'"
                  :column-type="meta.columns['package_name']"
                  :element="getElement('package_name', 'display', meta)"
                  :meta="meta"
                  :resource-type="resourceType"
                  :value="`(${model.data.attributes.package_name})`"
                ></presentation-field>
              </div>
              <presentation-field
                :column="'level'"
                :column-type="meta.columns['level']"
                :element="getElement('level', 'display', meta)"
                :meta="meta"
                :resource-type="resourceType"
                :value="model.data.attributes.level"
              ></presentation-field>
            </div>
          </div>
          <p v-if="resource.meta.config.component.subtitle_key" class="d-flex card-text fs-6">
            <presentation-field
              :column="resource.meta.config.component.subtitle_key"
              :column-type="meta.columns[resource.meta.config.component.subtitle_key]"
              :element="getElement(resource.meta.config.component.subtitle_key, 'display', meta)"
              :mutation="meta.elementTypes[resource.meta.config.component.subtitle_key].collection"
              :resource-type="resourceType"
              :show-id="$page.props.user.roles.includes('tech')"
              :value="model.data.attributes[resource.meta.config.component.subtitle_key]"
            ></presentation-field>
          </p>
        </div>
      </Link>
      <div class="d-flex card-body justify-content-end">
        <div class="level-background" style="width:12rem; min-width:12rem; max-width:12rem; margin-top:-1rem; margin-bottom:-1rem;" :style="'background:' + meta.decoration.options['level'][model.data.attributes.level]?.color">
          <div class="card-text feature-list-container p-3" style="background:rgba(255, 255, 255, 0.75); white-space:nowrap; height:100%;">
            <h6 class="fw-bold">{{ trans('models.features.name.plural') }}</h6>
            <feature-list :features="model.data.collections?.features"></feature-list>
          </div>
        </div>
        <div class="card-text p-3 bg-warning-subtle" style="width:12rem; min-width:12rem; max-width:12rem; margin-top:-1rem; margin-bottom:-1rem; margin-right:-1rem;">
          <h6 class="fw-bold">Abhängigkeiten</h6>
          <module-list :modules="model.data.collections?.dependencies"></module-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import FeatureList from "@/aspects/admin/components/Feature/FeatureList";
import Toggle from "@kanrisha/components/Elements/Form/Toggle";
import ModuleList from "@/aspects/admin/components/Modules/ModuleList";

export default {
  components: {
    ModuleList,
    Toggle,
    FeatureList,
    ColoredIcon,
    Link,
    PresentationField,
  },
  props: {
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // deprecated: this should go on options or config
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh'],
  setup(props) {
    const { getElement, meta, resourceType } = useResource(props, props.resource);

    const getGridStyle = (cols) => {
      return 'grid-template-columns: repeat(' + (cols ?? 4) + ', minmax(0, 1fr))';
    };

    return {
      getElement,
      getGridStyle,
      meta,
      resourceType,
    };
  },
};
</script>
